var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30-Copy",
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(4.375, 5.625)",
    fill: "#8996A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2559760_media_social_video_youtube_icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1871947,1.88602941 C11.1871947,1.78676471 11.0399948,0.992647059 10.6965283,0.645220588 C10.2549285,0.148897059 9.76426204,0.0992647059 9.51892882,0.0992647059 L9.46986218,0.0992647059 C7.94879623,0 5.69173064,0 5.64266399,0 C5.64266399,0 3.33653175,0 1.81546581,0.0992647059 L1.76639916,0.0992647059 C1.52106595,0.0992647059 1.03039951,0.148897059 0.588799721,0.645220588 C0.245333217,1.04227941 0.0981332868,1.83639706 0.0981332868,1.93566176 C0.0981332868,1.98529412 0,2.87867647 0,3.82169118 L0,4.66544118 C0,5.60845588 0.0981332868,6.50183824 0.0981332868,6.55147059 C0.0981332868,6.65073529 0.245333217,7.44485294 0.588799721,7.79227941 C0.981332868,8.23897059 1.4719993,8.28860294 1.76639916,8.33823529 C1.81546581,8.33823529 1.86453245,8.33823529 1.91359909,8.33823529 C2.79679867,8.4375 5.49546406,8.4375 5.59359735,8.4375 C5.59359735,8.4375 5.59359735,8.4375 5.59359735,8.4375 C5.59359735,8.4375 7.89972959,8.4375 9.42079553,8.33823529 L9.46986218,8.33823529 C9.71519539,8.28860294 10.2058618,8.23897059 10.6474616,7.79227941 C10.9909281,7.39522059 11.1381281,6.60110294 11.1381281,6.50183824 C11.1381281,6.45220588 11.2362613,5.55882353 11.2362613,4.61580882 L11.2362613,3.77205882 C11.285328,2.87867647 11.1871947,1.93566176 11.1871947,1.88602941 Z M7.55626308,4.31801471 L4.61226448,5.90625 C4.56319784,5.90625 4.56319784,5.95588235 4.51413119,5.95588235 C4.46506455,5.95588235 4.41599791,5.95588235 4.41599791,5.90625 C4.36693126,5.85661765 4.31786462,5.80698529 4.31786462,5.70772059 L4.31786462,2.48161765 C4.31786462,2.38235294 4.36693126,2.33272059 4.41599791,2.28308824 C4.46506455,2.23345588 4.56319784,2.23345588 4.66133112,2.28308824 L7.60532973,3.87132353 C7.70346301,3.92095588 7.75252966,3.97058824 7.75252966,4.06985294 C7.75252966,4.16911765 7.65439637,4.26838235 7.55626308,4.31801471 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#8996A0",
    strokeWidth: 0.625,
    cx: 10,
    cy: 10,
    r: 9.6875
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.cb7d80aa4798c95561fe0af92563ea33.svg";
export { ForwardRef as ReactComponent };